module.exports = __webpack_public_path__ + "static/media/nexa-bold.c9f309b3.otf";